import { NgModule } from '@angular/core';

import { ErrorsRoutingModule } from './errors.routing.module';

@NgModule({
  imports: [ErrorsRoutingModule],
})
export class ErrorsModule {}
